<template>
  <div>
    <md-tabs
      class="md-primary"
      md-alignment="left"
      md-sync-route
      @click.native="tabChange()"
    >
      <md-tab
        md-label="Calendar"
        md-icon="calendar_today"
        to="/admin"
        exact
      ></md-tab>

      <md-tab
        md-label="New"
        md-icon="note_add"
        to="/admin/appointment"
        exact
      ></md-tab>

      <!-- TODO hide for now  -->
      <md-tab v-if="false" md-label="Feed" md-icon="view_agenda"></md-tab>
    </md-tabs>
  </div>
</template>

<script>
import { eventBus } from "../eventbus";

export default {
  name: "AdminNavRow",
  data: function () {
    return {};
  },
  components: {},
  methods: {
    tabChange: function (tab) {
      if (tab == null && this.$route.path == "/admin/appointment") tab = "add";

      eventBus.adminTabChanged(tab);

      switch (tab) {
        case "add":
          eventBus.openCloseAdminRightDrawer(true);
          console.log("tab change event, click");
          break;
        case "feed":
          break;
        default:
          break;
      }
    },
    created: function () {},
  },
};
</script>

<style >
.md-toolbar .md-tabs {
  padding-left: 2px;
}
</style>